import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from 'modules';
import {IVodInfoData} from 'lib/api/vodInfo';
import Header from 'components/common/Header';

/**
 * 헤더 컨테이너
 */

const HeaderContainer = () => {
  const {vodData, editMode} = useSelector(({vodInfo, ui}: RootState) => ({
    vodData: vodInfo.titleFileInfo.data,
    editMode: ui.editMode,
  }));
  const [, setUserNick] = useState('');
  const [, setUserId] = useState('');
  const [, setNoteCnt] = useState(0);

  useEffect(() => {
    if (!vodData) return;

    const {response} = vodData as IVodInfoData;
    if (!response.info) return;

    const {login_nick, login_id, note_cnt} = response.info;

    setUserNick(login_nick); // 닉네임 셋팅
    setUserId(login_id); // 아이디
    setNoteCnt(note_cnt); // 쪽지 갯수
  }, [vodData]);

  return <Header editMode={editMode} />;
};

export default HeaderContainer;
